exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.label-cell[data-v-1e288292] {\n  display: flex;\n  /* justify-content: center; */\n  /* align-self: center;    <---- REMOVE */\n  align-items: center;\n  /* color: #ffffff; */\n}\n.label-cell.warning[data-v-1e288292] {\n  background-color: #e6a23c;\n  color: #ffffff;\n}\n.label-cell.danger[data-v-1e288292] {\n  background-color: #f56c6c;\n\n  color: #ffffff;\n}\n.label-cell.success[data-v-1e288292] {\n  background-color: #67c23a;\n\n  color: #ffffff;\n}\n.label-cell.primary[data-v-1e288292] {\n  background-color: #409eff;\n\n\n  color: #ffffff;\n}\n\n\n/* round{\n   \n} */\n", ""]);

// exports
